"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Status = exports.OrderOrigin = void 0;

var _EventHandler = _interopRequireDefault(require("../../Events/EventHandler"));

var _Payment = _interopRequireWildcard(require("../Payment"));

var _Delivery = _interopRequireWildcard(require("../Delivery"));

var _Gift = _interopRequireDefault(require("../Gift"));

var _Cart = _interopRequireDefault(require("../Cart"));

var _Store = _interopRequireDefault(require("../Store"));

var _Cashback = _interopRequireDefault(require("../Cashback"));

var _Exception = require("../../Exceptions/Exception");

var _ExceptionCode = require("../../Exceptions/ExceptionCode");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const Status = {
  REJECTED: -2,
  CANCELLED: -1,
  WAITING_PAYMENT: 0,
  OPENED: 1,
  IN_PRODUCTION: 2,
  ON_DELIVERY: 3,
  FINISHED: 4
};
exports.Status = Status;
const OrderOrigin = {
  APP: 1,
  DESK: 2,
  PHONE: 3,
  TABLE: 4
};
exports.OrderOrigin = OrderOrigin;

class Order extends _EventHandler.default {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "id", null);

    _defineProperty(this, "payment", null);

    _defineProperty(this, "cart", null);

    _defineProperty(this, "delivery", null);

    _defineProperty(this, "gift", null);

    _defineProperty(this, "cashback", null);

    _defineProperty(this, "status", Status.WAITING_PAYMENT);

    _defineProperty(this, "total", null);

    _defineProperty(this, "auto_close", false);

    _defineProperty(this, "created_by", null);

    _defineProperty(this, "created_at", null);

    _defineProperty(this, "order_id", null);

    _defineProperty(this, "position", null);

    _defineProperty(this, "subtotal", null);

    _defineProperty(this, "origin", null);

    _defineProperty(this, "is_edited", false);

    _defineProperty(this, "observation", null);
  }

  static fromObject(obj) {
    return Object.keys(obj || {}).reduce((o, key) => {
      let value = obj[key];

      switch (key) {
        case 'payment':
          o.payment = _Payment.default.fromObject(value);
          break;

        case 'delivery':
          //TODO: Implementação do fromJSON e criação do objeto Delivery
          o.delivery = _Delivery.default.fromObject(value);
          break;

        case 'gift':
          //TODO: Implementação do fromJSON e criação do objeto Gift
          o.gift = value ? _Gift.default.fromObject(value) : null;
          break;

        case 'cashback':
          //TODO: Implementação do fromJSON e criação do objeto Cashback
          Object.defineProperty(o, 'cashback', {
            value: value ? Object.freeze(_Cashback.default.fromObject(value)) : null,
            writable: false,
            enumerable: true,
            configurable: false
          });
          break;

        case 'is_edited':
          o.is_edited = !!value;
          break;

        case '_id':
        case 'id':
        case 'order_id':
        case 'total':
        case 'auto_close':
        case 'subtotal':
        case 'status':
        case 'origin':
        case 'position':
        case 'observation':
        case 'created_by':
        case 'created_at':
        case 'user_id':
        case 'user_name':
          o[key] = value;
          break;

        case 'cart':
          o.cart = _Cart.default.fromObject(value);
          break;
      }

      return o;
    }, new Order());
  }

  validate() {
    let me = this;
    let storeConfigs = this.trigger('order/getStoreConfigs');

    let store = _Store.default.fromObject(storeConfigs); //verifica se pedido balcão está bloqueado


    if (this.origin == OrderOrigin.APP && this.delivery.type == _Delivery.DeliveryType.GET_ON_PLACE && store.keys && store.keys.hideOnlineLocation) {
      throw new Error('Pedido balcão bloqueado');
    }

    store.on('store/isOnlineOrigin', () => this.origin == OrderOrigin.APP);
    store.validate(); //Valida o carrinho de compras

    if (!this.cart) {
      throw new Error('Carrinho vazio');
    }

    this.cart.on('cart/getCatalogList', cart => me.trigger('order/getCatalogList'));
    this.cart.on('cart/getStoreConfigs', cart => store);
    this.cart.validate(); //Verifica se o gift é válido

    if (this.gift) {
      this.gift.on('gift/isOnlineOrigin', () => this.origin == OrderOrigin.APP);
      this.gift.on('gift/getCartTotal', gift => me.cart.total);
      this.gift.on('gift/getLastOrder', gift => me.trigger('order/getLastOrder', gift));
      this.gift.on('gift/checkGift', gift => me.trigger('order/checkGift', gift));
      this.gift.on('gift/countOrders', gift => me.trigger('order/countGiftOrders', gift));
      this.gift.validate();
    } //Valida o endereço e a entrega


    if (!this.delivery) {
      throw new _Exception.Exception(_ExceptionCode.ExceptionCode.DELIVERY_NOT_DEFINED);
    }

    if (me.delivery.address) {
      this.delivery.on('delivery/isOnlineOrigin', () => this.origin == OrderOrigin.APP);
      this.delivery.on('delivery/getCartTotal', () => me.cart.total);
      this.delivery.on('delivery/getStoreGeolocation', () => store.location.geolocation);
      this.delivery.on('delivery/getDelivery', () => store.delivery_region);
      this.delivery.validate();
    } //Comparar total calculado com o valor informado


    let total = this.cart.total + this.delivery.total + (this.gift ? this.gift.getValue(this.cart.total, this.delivery.total) : 0);

    if (total.toFixed(2) != this.total.toFixed(2)) {
      throw new Error('Pedido inválido');
    }

    if (!this.payment) {
      throw new Error('Pagamento não informado');
    }

    this.payment.on('payment/getOrder', () => this);
    this.payment.on('payment/getAvailableMethods', payment => storeConfigs.payment_methods);
    this.payment.on('payment/getUser', (payment, payer) => me.trigger('order/getUser', payment, payer));
    this.payment.validate();

    if (this.payment === _Payment.Status.WAITING) {
      this.status = Status.WAITING_PAYMENT;
    } //Verifica se o total pago é igual ao total cobrado


    if (total.toFixed(2) != this.payment.total.toFixed(2)) {
      throw new Error('Pedido inválido');
    }

    if (!this.is_edited && !this.cashback) {
      this.cashback = new _Cashback.default();
    }

    this.cashback.on('cashback/hasGift', () => this.gift);
    this.cashback.on('cashback/getPayers', () => {
      var _this$payment;

      return (_this$payment = this.payment) === null || _this$payment === void 0 ? void 0 : _this$payment.payers;
    });
    this.cashback.on('cashback/isOnlineOrigin', () => this.origin == OrderOrigin.APP);
    this.cashback.on('cashback/getCashbackConfigs', () => storeConfigs === null || storeConfigs === void 0 ? void 0 : storeConfigs.cashback);
    this.cashback.on('cashback/getCartTotal', () => this.cart.total);
    this.cashback.on('cashback/getDeliveryTotal', () => {
      var _this$delivery;

      return ((_this$delivery = this.delivery) === null || _this$delivery === void 0 ? void 0 : _this$delivery.total) || 0;
    });
    this.cashback.on('cashback/getOrderTotal', () => total);
    let isCashbackValid = this.cashback.validate();

    if (!isCashbackValid) {
      this.cashback = null;
    }
  }

}

exports.default = Order;